import React from "react";
import {
    Draggable,
    DraggableProvided,
    Droppable,
    DroppableProvided,
} from "react-beautiful-dnd";

import {IRowId} from "./models";

export interface IDragDropRowProps<TValue> {
    values: TValue[];

    getId?(value: TValue): string;
    renderContent(sample: TValue, i: number): React.ReactNode;
}

class DragDropRow<TValue extends IRowId> extends React.PureComponent<
    IDragDropRowProps<TValue>
> {
    public render() {
        return (
            <Droppable droppableId="droppable-table">
                {(droppableProvided: DroppableProvided) => (
                    <tbody
                        ref={droppableProvided.innerRef}
                        {...droppableProvided.droppableProps}
                    >
                        {this.renderRows()}
                        {droppableProvided.placeholder}
                        {this.props.children}
                    </tbody>
                )}
            </Droppable>
        );
    }

    private renderRows() {
        return this.props.values.map((value, i) => this.renderRow(value, i));
    }

    private renderRow(value: TValue, i: number) {
        const {renderContent, getId} = this.props;
        const id = value.id == undefined ? `${i}` : `${value.id}`;

        return (
            <Draggable key={id} draggableId={id} index={i}>
                {(provided: DraggableProvided) => (
                    <tr
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        id={getId?.(value)} // bottom most to overwrite
                    >
                        {renderContent(value, i)}
                    </tr>
                )}
            </Draggable>
        );
    }
}

export default DragDropRow;
